import { defineComponent as _defineComponent } from 'vue'
import { createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["data-express-id"]
const _hoisted_2 = {
  key: 1,
  class: "ifc-tree-node__toggle"
}
const _hoisted_3 = ["title"]
const _hoisted_4 = { class: "ifc-tree-node__name" }

import type { IfcNodeDto } from 'api/IfcParser/Application/Models/IfcNodeDto';
    import IfcIcon from 'Core/Components/Ifc/IfcIcon.vue';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'IfcTreeNode',
  props: {
    node: {},
    depth: {},
    expandedIds: {},
    selectedId: {},
    existingRecords: {}
  },
  emits: ["toggle", "select", "openExisting"],
  setup(__props: any, { emit: __emit }) {

    const props = __props;

    const emit = __emit;

    const hasChildren = () => props.node.children.length > 0;
    const isExpanded = () => !!props.expandedIds[props.node.expressId];
    const isSelected = () => props.selectedId === props.node.expressId;
    const isExistingRecord = () =>
        !!(
            props.node.globalId &&
            props.existingRecords &&
            props.existingRecords[props.node.globalId]
        );

return (_ctx: any,_cache: any) => {
  const _component_IfcTreeNode = _resolveComponent("IfcTreeNode", true)!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", {
      class: _normalizeClass(["ifc-tree-node", { 'ifc-tree-node--selected': isSelected() }]),
      style: _normalizeStyle({ paddingLeft: __props.depth * 10 + 4 + 'px' }),
      "data-express-id": __props.node.expressId,
      onClick: _cache[2] || (_cache[2] = ($event: any) => (emit('select', __props.node)))
    }, [
      _createCommentVNode(" Expand/collapse toggle "),
      (hasChildren())
        ? (_openBlock(), _createElementBlock("span", {
            key: 0,
            class: "ifc-tree-node__toggle",
            onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (emit('toggle', __props.node)), ["stop"]))
          }, [
            _createElementVNode("i", {
              class: _normalizeClass(isExpanded() ? 'fa fa-caret-down' : 'fa fa-caret-right')
            }, null, 2 /* CLASS */)
          ]))
        : (_openBlock(), _createElementBlock("span", _hoisted_2)),
      _createCommentVNode(" Icon "),
      _createVNode(IfcIcon, {
        class: "ifc-tree-node__icon",
        "ifc-class": __props.node.ifcClass,
        size: 14
      }, null, 8 /* PROPS */, ["ifc-class"]),
      _createCommentVNode(" Name "),
      _createElementVNode("span", {
        class: "ifc-tree-node__label",
        title: __props.node.name || 'Unnamed'
      }, [
        _createElementVNode("span", _hoisted_4, _toDisplayString(__props.node.name || 'Unnamed'), 1 /* TEXT */)
      ], 8 /* PROPS */, _hoisted_3),
      _createCommentVNode(" Existing record link "),
      (isExistingRecord())
        ? (_openBlock(), _createElementBlock("a", {
            key: 2,
            class: "ifc-tree-node__existing",
            href: "javascript:;",
            title: 'Click to open record',
            onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (emit('openExisting', __props.node)), ["stop"]))
          }, [...(_cache[6] || (_cache[6] = [
            _createElementVNode("i", { class: "fa fa-external-link" }, null, -1 /* CACHED */)
          ]))]))
        : _createCommentVNode("v-if", true)
    ], 14 /* CLASS, STYLE, PROPS */, _hoisted_1),
    (hasChildren() && isExpanded())
      ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(__props.node.children, (child) => {
          return (_openBlock(), _createBlock(_component_IfcTreeNode, {
            key: child.expressId,
            node: child,
            depth: __props.depth + 1,
            "expanded-ids": __props.expandedIds,
            "selected-id": __props.selectedId,
            "existing-records": __props.existingRecords,
            onToggle: _cache[3] || (_cache[3] = (n) => emit('toggle', n)),
            onSelect: _cache[4] || (_cache[4] = (n) => emit('select', n)),
            onOpenExisting: _cache[5] || (_cache[5] = (n) => emit('openExisting', n))
          }, null, 8 /* PROPS */, ["node", "depth", "expanded-ids", "selected-id", "existing-records"]))
        }), 128 /* KEYED_FRAGMENT */))
      : _createCommentVNode("v-if", true)
  ]))
}
}

})